import { render, staticRenderFns } from "./TuitionCenter.vue?vue&type=template&id=1f998c89&"
import script from "./TuitionCenter.vue?vue&type=script&lang=js&"
export * from "./TuitionCenter.vue?vue&type=script&lang=js&"
import style0 from "./TuitionCenter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports